/* BHALLO — "Avise-me quando voltar": mostra o formulario quando a variante esta esgotada
   e grava o tamanho escolhido nas etiquetas, pra o lojista saber o que repor. */
(function () {
  function init() {
    var box = document.getElementById('BhalloNotify');
    if (!box) return;

    var realBtn = document.querySelector('.product-form__submit');
    if (!realBtn) {
      box.remove();
      return;
    }

    var tags = document.getElementById('BhalloNotifyTags');
    var base = tags ? tags.getAttribute('data-base') || '' : '';
    var jaEnviou = !!box.querySelector('.bhallo-notify__ok');

    function opcoesEscolhidas() {
      var vals = [];
      var nodes = document.querySelectorAll(
        'variant-selects input:checked, variant-selects select, variant-radios input:checked'
      );
      for (var i = 0; i < nodes.length; i++) {
        var v = nodes[i].value;
        if (v) vals.push(String(v).trim().replace(/,/g, ''));
      }
      return vals;
    }

    function sync() {
      var esgotado = realBtn.disabled;
      box.hidden = !(esgotado || jaEnviou);
      if (tags && esgotado) {
        var partes = [base].concat(opcoesEscolhidas());
        tags.value = partes.join(',').replace(/,{2,}/g, ',');
      }
    }

    sync();

    if (window.MutationObserver) {
      new MutationObserver(sync).observe(realBtn, {
        attributes: true,
        attributeFilter: ['disabled']
      });
    }

    // quando troca de tamanho, o Dawn recria o botao — re-sincroniza
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios')) {
        setTimeout(function () {
          var novo = document.querySelector('.product-form__submit');
          if (novo && novo !== realBtn) {
            realBtn = novo;
            if (window.MutationObserver) {
              new MutationObserver(sync).observe(realBtn, {
                attributes: true,
                attributeFilter: ['disabled']
              });
            }
          }
          sync();
        }, 120);
      }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
